import { useQuery, useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { companies } from '../Companies';

type OptionsType = {
  enabled: boolean;
};

export const useCompanies = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.company],
    queryFn: async () => (await companies.getCompanies()).data,
    enabled: options?.enabled,
  });

export const useCreateCompany = () =>
  useMutation({ mutationFn: companies.createCompanies });
export const useUpdateCompany = () =>
  useMutation({ mutationFn: companies.updateCompanies });
